import React from "react";
import { motion } from "framer-motion";

// Fade + rise on scroll into view
export function Reveal({ children, delay = 0, y = 28, className = "", as = "div" }) {
  const M = motion[as] || motion.div;
  return (
    <M
      className={className}
      initial={{ opacity: 0, y }}
      whileInView={{ opacity: 1, y: 0 }}
      viewport={{ once: true, margin: "-80px" }}
      transition={{ duration: 0.8, delay, ease: [0.22, 1, 0.36, 1] }}
    >
      {children}
    </M>
  );
}

// Masked line-by-line reveal (each line rises from behind a mask)
export function MaskLines({ lines, className = "", lineClassName = "", start = false, delayBase = 0 }) {
  return (
    <span className={className}>
      {lines.map((line, i) => (
        <span key={i} className="reveal-mask">
          <motion.span
            className={`block ${lineClassName}`}
            initial={{ y: "110%" }}
            animate={start ? { y: "0%" } : undefined}
            whileInView={start ? undefined : { y: "0%" }}
            viewport={{ once: true }}
            transition={{ duration: 0.9, delay: delayBase + i * 0.12, ease: [0.16, 1, 0.3, 1] }}
          >
            {line}
          </motion.span>
        </span>
      ))}
    </span>
  );
}
